// Zentrale Datenquelle der Werkstatt-SEO-Plattform (aus FuelX_500_Werkstatt_Keywords.xlsx generiert).
// Änderungen am Veröffentlichungsstatus: "published"-Flag in den JSON-Dateien umstellen,
// danach `node scripts/validate-werkstatt.js && node scripts/generate-sitemap.js` ausführen.
import pagesA from './pagesA.json';
import pagesB from './pagesB.json';
import pagesC from './pagesC.json';

export const WERKSTATT_PAGES = [...pagesA, ...pagesB, ...pagesC];

export const WERKSTATT_BY_PATH = Object.fromEntries(WERKSTATT_PAGES.map((p) => [p.path, p]));

export const WERKSTATT_PUBLISHED = WERKSTATT_PAGES.filter((p) => p.published);

/** Gruppen für den Hub — nur veröffentlichte Seiten. */
export const HUB_GROUPS = [
  ['Symptome & Diagnose', ['diagnose', 'symptom']],
  ['Bremsen & Fahrwerk', ['bremsen', 'fahrwerk']],
  ['Motor & Antrieb', ['motor', 'getriebe']],
  ['Elektrik & Batterie', ['elektrik']],
  ['Abgas & Diesel', ['abgas']],
  ['Karosserie, Glas & Lack', ['karosserie']],
  ['Service, Wartung & Kosten', ['service', 'kosten', 'lokal']],
  ['Marken & Spezialwerkstätten', ['marke', 'spezial']],
].map(([label, groups]) => ({
  label,
  pages: WERKSTATT_PUBLISHED.filter((p) => groups.includes(p.group)),
})).filter((g) => g.pages.length > 0);
